import React, { Component } from 'react';
import { Bar } from 'react-chartjs-2';
import { format, parse } from 'date-fns';
import './PlayerRegistration.scss';

class PlayerRegistration extends Component {
    constructor(props) {
        super(props);
        this.chartRef = React.createRef();
        this.extractData = this.extractData.bind(this);
    }

    options = {
        responsive: true,
        legend: {
            display: false
        },
        scales: {
            yAxes: [
                {
                    ticks: {
                        beginAtZero: true
                    },
                    gridLines: {
                        display: false
                    }
                }
            ],
            xAxes: [
                {
                    // Change the width of the bars in the bar chart
                    barPercentage: 0.2,
                    gridLines: {
                        display: false
                    }
                }
            ]
        },
        title: {
            display: false,
            text: 'Player Registration'
            // fontColor: 'var(--blue)' // todo color with variable not working
        }
    };

    extractData() {
        return () => {
            let registrations = [...this.props.data].reverse();

            return {
                labels: registrations.map(d => this.parseMonth(d.month)),
                datasets: [
                    {
                        data: registrations.map(d => d.registrations),
                        label: 'Registrations',
                        backgroundColor: '#2B5BE2'
                    }
                ]
            };
        };
    }

    parseMonth(data) {
        return format(parse(data), 'MMM');
    }

    render() {
        let data = this.extractData();
        return (
            <div className="line-chart">
                <Bar ref={this.chartRef} data={data} options={this.options} />
            </div>
        );
    }
}

export default PlayerRegistration;
